import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../data/queryClient.ts";
import { AuthGate } from "../auth/AuthGate.tsx";
import { AuthProvider } from "../auth/AuthProvider.tsx";
import { PhantomStatusProvider } from "../auth/PhantomStatusProvider.tsx";
import { UserProfileProvider } from "../auth/UserProfileProvider.tsx";
import { ThemeProvider } from "./ThemeProvider.tsx";
import { AppRoutes } from "./routes.tsx";

// Top-level app composition.
// Order: BrowserRouter → AuthProvider → UserProfileProvider →
//        PhantomStatusProvider → AuthGate → AppRoutes.
// AuthGate consumes all three context providers; PhantomStatusProvider must
// be nested inside AuthProvider so it can read the authenticated user.
export function App(): JSX.Element {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <UserProfileProvider>
              <PhantomStatusProvider>
                <AuthGate>
                  <AppRoutes />
                </AuthGate>
              </PhantomStatusProvider>
            </UserProfileProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
